// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@steiner/App/SharedStyles/CartLineSharedStyles";
import { requestRmaProductListStyles } from "@steiner/Overrides/Widgets/RequestRma/RequestRmaProductList";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { mergeWithCss, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

requestRmaProductListStyles.tableWrapper = {
    container: {
        css: css`
            margin: 24px 0;
        `,
    },
};

requestRmaProductListStyles.productTotalPriceHeadingAndText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};

requestRmaProductListStyles.cartLineNotesStyles = {
    ...cartLineSharedStyles.cartLineNotes,
};

requestRmaProductListStyles.productDescriptionStyles = {
    ...cartLineSharedStyles.productDescription,
};

requestRmaProductListStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};

requestRmaProductListStyles.returnReasonSelect = {
    mergeCss: true,
    cssOverrides: {
        formField: css`
            width: auto;
            margin-top: 10px;
        `,
        formInputWrapper: css`
            max-width: 225px;
            width: 225px;
            ${xScreen("lte", "xs")} {
                max-width: 100%;
            }
        `,
    },
};

requestRmaProductListStyles.qtyToReturnTextField = {
    cssOverrides: {
        formField: css`
            width: 100px;
            margin-right: auto;
            ${xScreen("lte", "xs")} {
                margin-right: 0;
            }
        `,
        formInputWrapper: css`
            width: 90px;
        `,
    },
};

requestRmaProductListStyles.gridContainer = {
    css: css`
        margin-bottom: 25px;
    `,
};

requestRmaProductListStyles.cartLineContainerStyles = {
    description: {
        css: css`
            grid-column: 2 / 3;
            grid-row: 1 / 3;
            ${xScreen("lte", "md")} {
                grid-row: 1 / 2;
                grid-column: 2 / 9;
            }
        `,
    },
    actions: {
        css: css`
            grid-column: 3 / 7;
            grid-row: 2 / 3;
            ${xScreen("lte", "md")} {
                grid-column: 1 / 9;
                grid-row: 4 / 5;
            }
            ${xScreen("lt", "md")} {
                grid-column: 1 / 9;
                grid-row: 5 / 6;
            }
        `,
    },
};

requestRmaProductListStyles.priceHeading = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.heading,
};

requestRmaProductListStyles.priceText = {
    ...mergeWithCss(cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.text, {
        css: css`
            display: inline-flex;
            width: auto;
        `,
    }),
};

requestRmaProductListStyles.unitOfMeasure = {
    ...mergeWithCss(cartLineSharedStyles.unitOfMeasure, {
        css: css`
            display: inline-flex;
            line-height: ${fontConfig.lineHeight.xSmall};
            margin-left: 4px;
        `,
    }),
};

requestRmaProductListStyles.orderLineCardImage = {
    css: css`
        ${cartLineSharedStyles?.productImage?.linkWrappingImage?.css}
    `,
};


requestRmaProductListStyles.actionsContainer = {
    css: css`
        margin-top: 22px;
    `,
};

requestRmaProductListStyles.qtyFieldWrapper = {
    css: css`
        margin: 0px auto 0px 0px;
        padding: 0px;
        border: 0px;
        display: inline-flex;
        flex-direction: column;
        width: 100px;
        margin-right: 10px;
    `
};

requestRmaProductListStyles.editableQuantityTextField = {
    labelText: {
        forwardAs: "label",
        weight: 600,
    }
};